/**
 * @file step
 * @author zhaomiaoyuan
 */
import React, {useCallback} from 'react';
import {Button} from 'antd';
import {recordProxy} from '../../util';

const VerifySelf = () => {
    /* eslint-disable */
    const onGuide = useCallback(() => {
        recordProxy('url-companyGuide', 'click', '查看修改教程');
        window.location.href = '//haoma.baidu.com/companyGuide';
    });
    const onSpnsUrl = useCallback(() => {
        recordProxy('url-spns', 'click', '前往百度云修改');
        window.location.href = '//console.bce.baidu.com/spns/#/';
    });
    /* eslint-enable */
    return (
        <div className="verify-msg-self">
            <div className="verify-main-content">
                请前往百度云自行修改
            </div>
            <div className="verify-btn-group">
                <Button
                    className="verify-btn-next verify-btn"
                    onClick={onGuide}
                >
                    查看修改教程

                </Button>
                <Button
                    className="verify-btn-main verify-btn"
                    type="primary"
                    onClick={onSpnsUrl}

                >
                    前往百度云修改
                </Button>
            </div>

        </div>
    );
};
// VerifyThirdPart.propTypes = {
//     updateVerifyMsg: PropTypes.func,
//     verifyMsgData: PropTypes.object,
// };

export default VerifySelf;